import { get } from 'lodash-es';
import * as moment from 'moment';

import HeaderDetailsBaseService from './headerDetails.baseService';

interface IBuyer {
  name?: string;
  profile?: {
    name: string;
  };
}

/**
 * This requires the use of ng-bind-html
 * <span ng-bind-html="$ctrl.origText | aptHighlight:$ctrl.stringToHighlight"
 * I originally intended to make this a directive or component but that turned out to be troublesome when using with the grid at least
 * so this turned out to be simpler and less code
 */
class HeaderDetailsRfpService extends HeaderDetailsBaseService {
  get rfp(): any {
    return this.data;
  }

  get id() {
    return this.rfp.id || this.rfp.requestId;
  }

  get type() {
    return this.rfp.type || this.rfp.rfpType;
  }

  get typeDescription() {
    return `Request For Pricing (${this.type})`;
  }

  get buyerName() {
    let buyer: IBuyer = get(this.rfp, 'buyer', {});

    if (buyer.profile) {
      return buyer.profile.name;
    } else {
      return buyer.name;
    }
  }

  // this is the type of the data set not the type of RFP
  get dataType() {
    return 'rfp';
  }

  get categoryName() {
    if (this.rfp.category && this.rfp.category.name) {
      return this.rfp.category.name;
    } else if (this.rfp.productCategory && this.rfp.productCategory.name) {
      return this.rfp.productCategory.name;
    } else {
      return 'Custom Category Name Required*';
    }
  }

  get spendStartDate() {
    if (this.hasCustomSpendDate()) {
      let { startDate } = this.rfp.rfpCustomSpendDateRange;
      return moment(startDate).format(this.dateFormat);
    } else {
      let sendDateTimeStamp = this.getSendDateTimestamp();
      if (sendDateTimeStamp) {
        return moment(sendDateTimeStamp)
          .subtract(14, 'months')
          .startOf('month')
          .format(this.dateFormat);
      } else {
        return moment()
          .subtract(14, 'months')
          .startOf('month')
          .format(this.dateFormat);
      }
    }

  }

  get spendEndDate() {
    if (this.hasCustomSpendDate()) {
      let { endDate } = this.rfp.rfpCustomSpendDateRange;
      return moment(endDate).format(this.dateFormat);
    } else {
      let sendDateTimeStamp = this.getSendDateTimestamp();

      if (sendDateTimeStamp) {
        return moment(sendDateTimeStamp)
          .subtract(3, 'months')
          .endOf('month')
          .format(this.dateFormat);
      } else {
        return moment()
          .subtract(3, 'months')
          .endOf('month')
          .format(this.dateFormat);
      }
    }

  }

  get createdBy() {
    if (this.rfp.submittedBy) {
      return this.rfp.submittedBy.emailAddress;
    } else if (this.rfp.requestedBy) {
      return this.rfp.requestedBy.email;
    }
  }

  get showTimeline() {
    return this.type === 'RFP';
  }

  private hasCustomSpendDate() {
    let { hasCustomSpendDateRange } = this.rfp.rfpCustomSpendDateRange;
    return hasCustomSpendDateRange;
  }
  private getSendDateTimestamp() {
    // support RFP API v1 and v2
    let { sendDate, submissionDate } = this.rfp;
    return sendDate || submissionDate;
  }
}

export default function HeaderDetailsRfpFactory() {
  return function (rfpData) {
    return new HeaderDetailsRfpService(rfpData);
  };
}
